import { STATES } from '../../constants';

export function InviteConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.INVITE, {
    url: '/invite/{inviteToken:[0-9a-f-]{36}}',
    disableBreadcrumb: true,
    analytics: {
      page: 'Invite',
    },
    views: {
      '@': {
        template: '<upd-welcome></upd-welcome>',
      },
    },
    data: {
      permissions: 'anyone',
    },
  });
}
